module.exports = __webpack_public_path__ + "static/img/visual_title.192945a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/visual_title.png
// module id = k6G5
// module chunks = 0